const RouteComponent = () => import('@/views/route/RouteView')

export default [
    {
        path:'/RouteIndex',
        name:'RouteRouter',
        component:RouteComponent
    }
]